/* eslint-disable sort-keys-fix/sort-keys-fix */
import { COMMUNITY_PAGES_PATH_PREFIX, type CommunityData } from "./types"

const MAGMIX_LOGO =
  "https://media.werz.at/community/icon/cmo1dysec00009kxwyylu2z3h.png?uploadTime=1776368738926&type=image"

const magmix: CommunityData = {
  code: "magmix",
  inviteCode: "magmix",
  name: "MAGMIX",
  thumbnail: "",
  favicon: "",
  defaultCurrency: "SEK",
  url: `${COMMUNITY_PAGES_PATH_PREFIX}/mag-001`,
  socials: {},
  styles: {
    global: {
      mobileOnly: true,
      counterColor: "#ffffff",
      logo: {
        src: MAGMIX_LOGO,
        styles: "w-[96px] h-[96px] object-contain",
      },
      alternativeLogo: {
        src: MAGMIX_LOGO,
        styles: "w-[96px] h-[96px] object-contain",
      },
      modalWindow: {
        container: "",
        title: "",
        subtitle: "",
      },
      bgColor: "#000000",
      asideBg: "#000000",
      asideStyles: "border-r border-[#ffffff]",
      contentBg: "#000000",
      contentBoxShadow: "",
      bgDesktop: "",
      bgMobile: "",
      nonMemberBg: "",
      mainFont: "font-['OCRATributeW01-RegularMonoRegular']",
      primaryButton:
        "bg-[#000000] border border-[#ffffff] px-[18px] py-[18px] !text-[#ffffff] font-['OCRATributeW01-RegularMonoRegular'] !text-[14px] uppercase text-left leading-[100%]",
    },
    navigation: {
      iconsColor: "#ffffff",
      sideBarSeparator: "border-r border-[#ffffff]",
      separator: "border-[#ffffff]",
      item: "text-[#ffffff] font-['OCRATributeW01-RegularMonoRegular'] text-[14px] uppercase text-left leading-[100%] text-opacity-60 border-b border-[#ffffff] !pl-0 !py-3",
      itemSelected: "!text-opacity-100",
    },
    communityLanding: {
      container: "!bg-[#000000] border border-[#ffffff] !pb-8",
      titles:
        "text-[#ffffff] font-['OCRATributeW01-RegularMonoRegular'] text-[24px] uppercase text-left leading-[110%]",
      emptyOrLoadingState:
        "!mx-4 sm:!mx-8 text-[#ffffff] font-['OCRATributeW01-RegularMonoRegular'] text-[14px] text-left leading-[120%]",
      shop: {
        container: "py-4 sm:py-8 !pb-16 !m-0 space-y-0 !border-0",
        sectionTitle: "hidden",
        title:
          "text-[#ffffff] font-['OCRATributeW01-RegularMonoRegular'] text-[20px] uppercase text-left leading-[110%]",
        text: "text-[#ffffff] font-['OCRATributeW01-RegularMonoRegular'] text-[14px] text-left leading-[120%]",
      },
    },
  },
}

export default magmix
